import React from 'react';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon, GlobeIcon, LockIcon, WrenchIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { IMAGES } from '../data/links';
const bonusList = ['The Intelligent Sensory Intake Guide™', 'The 15-Minute Sensory Case Organizer™', 'The Sensory Modulation Clinical Glossary™', '10 Sensory Modulation Case Reasoning Challenges™', 'The Clinical Progress & Functional Goal Tracker™'];
const perks = ['One-time payment', 'No monthly subscription', 'Instant digital access', 'Lifetime access to the purchased materials', '7-Day Guarantee'];
export function Offer() {
  return <section id="offer" className="bg-brand-dark px-3 py-16 sm:px-4 sm:py-24" data-id="element-208" data-mp="ywd50b39jgt2">
      <div className="mx-auto max-w-3xl text-center" data-id="element-209" data-mp="2fb4ykrc5au3y">
        <p className="inline-block rounded-full bg-amber-400 px-4 py-1.5 text-[12px] font-extrabold uppercase tracking-wider text-ink" data-id="element-210" data-mp="2fe0ts7wlz4op">
          Special launch offer
        </p>
        <h2 className="mt-4 text-balance font-serif text-[30px] font-extrabold leading-tight text-white sm:text-[44px]" data-id="element-211" data-mp="pjyyrhmfktsg">
          Here’s Everything You’ll Receive Today
        </h2>
      </div>

      <div className="mx-auto mt-10 max-w-2xl overflow-hidden rounded-3xl bg-white shadow-[0_24px_60px_rgba(0,0,0,0.35)]" data-id="element-212" data-mp="zj6cw70zosgm">
        <img src={IMAGES.mockup} alt="Everything included in the Sensory Modulation Clinical Pathway" className="block w-full bg-cream" data-id="element-213" data-mp="6tppxow523rs" />

        <div className="px-5 pb-8 pt-4 sm:px-10 sm:pb-10" data-id="element-214" data-mp="btvm9idcseg7">
          <ul className="divide-y divide-black/[0.07]" data-id="element-215" data-mp="fufj0ku0lg1t">
            <StackRow icon={<BookOpenIcon className="h-5 w-5" data-id="element-217" data-mp="ft4geocb2eca" />} title="The Sensory Modulation Clinical Pathway™" detail="6 Premium Volumes" value="$97" data-id="element-216" data-mp="ftmapffeqihk" />
            <StackRow icon={<WrenchIcon className="h-5 w-5" data-id="element-219" data-mp="3k7krgu7ghomy" />} title="The Complete Sensory Modulation Decision Toolkit™" detail="Observation maps, reasoning matrices, checklists, and practical worksheets." value="Included" data-id="element-218" data-mp="3k8vq6fm1o677" />
            <li className="py-4" data-id="element-220" data-mp="qgxhm4465bpe">
              <div className="flex items-start gap-3" data-id="element-221" data-mp="qfmhce9xmm31">
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-brand-soft text-brand" data-id="element-222" data-mp="155k6oxjllhtt">
                  <GiftIcon className="h-5 w-5" data-id="element-223" data-mp="106pc6yc9q4tv" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-224" data-mp="108tghhe2x5uo">
                  <div className="flex items-start justify-between gap-3" data-id="element-225" data-mp="chxu4zse72ut">
                    <p className="text-[16px] font-bold leading-snug text-ink" data-id="element-226" data-mp="7i1rb3vflhgu">5 Professional Bonuses</p>
                    <span className="shrink-0 text-[15px] font-bold text-muted line-through" data-id="element-227" data-mp="li2q8ds4yeto">$147</span>
                  </div>
                  <ul className="mt-2 space-y-1.5" data-id="element-228" data-mp="hf6dv4t6vey6">
                    {bonusList.map(b => <li key={b} className="flex items-start gap-2 text-[14px] leading-snug text-muted" data-id="element-229" data-mp="1wvewswfa5bjj">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-230" data-mp="1sul9o59nw0rp" />
                        {b}
                      </li>)}
                  </ul>
                </div>
              </div>
            </li>
          </ul>

          <div className="mt-2 rounded-2xl bg-cream px-4 py-4 text-center" data-id="element-231" data-mp="1qh99r0z48274">
            <p className="text-[13px] font-bold uppercase tracking-wider text-muted" data-id="element-232" data-mp="1vfatlo4d85jn">Total suggested reference value</p>
            <p className="mt-1 font-serif text-3xl font-extrabold text-red-600 line-through" data-id="element-233" data-mp="2j4visor43z1d">$244</p>
          </div>

          <p className="mt-6 text-center text-[17px] font-semibold text-ink" data-id="element-234" data-mp="2o2x0b58w3qaq">But you don’t need to pay $244.</p>
          <p className="mt-1 text-center text-[16px] text-muted" data-id="element-235" data-mp="29esmofop24yt">Get the Complete Sensory Modulation Clinical Pathway™ Today for Just:</p>
          <p className="mt-2 text-center font-serif font-black leading-none text-cta-dark" data-id="element-236" data-mp="323zjna8i2mhy">
            <span className="align-top text-2xl" data-id="element-237" data-mp="36upqkrwkqxer">USD</span> <span className="text-[84px] sm:text-[96px]" data-id="element-238" data-mp="36vho489qf57o">$27</span>
          </p>

          <ul className="mx-auto mt-5 grid max-w-md grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-239" data-mp="1j6o7cibvni7o">
            {perks.map(p => <li key={p} className="flex items-start gap-2 text-[14px] font-medium leading-snug text-ink" data-id="element-240" data-mp="1e6icyue83hlw">
                <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-cta" aria-hidden="true" data-id="element-241" data-mp="198qj3uu0plf2" />
                {p}
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-242" data-mp="21x5l9gs1w98z">
            <ScarcityBar data-id="element-243" data-mp="21wckcwfrwdyr" />
          </div>

          <CTAButton className="mt-7" label="Get instant access now" sublabel="Instant digital access · One-time payment of USD $27 · 7-Day Guarantee" data-id="element-244" data-mp="1wy2saupchthd" />

          <div className="mt-7" data-id="element-245" data-mp="1n89f5p9k16b0">
            <Countdown data-id="element-246" data-mp="1n6y9tl0gnqhs" />
          </div>

          <div className="mt-7 flex items-start gap-3 rounded-2xl border border-brand/15 bg-brand-soft px-4 py-4" data-id="element-247" data-mp="1n65erhav6pfh">
            <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-248" data-mp="2fwngoezuqkrb" />
            <p className="text-[14px] leading-relaxed text-ink" data-id="element-249" data-mp="2fuu9mylbtyis">
              <strong data-id="element-250" data-mp="2o6vwguh3szvg">Automatic currency conversion.</strong> Wherever you are, your payment provider automatically displays the price in
              your local currency at checkout.
            </p>
          </div>

          <p className="mt-4 flex items-center justify-center gap-1.5 text-[12px] text-muted" data-id="element-251" data-mp="2x82ex93bckrc">
            <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-252" data-mp="326dmtea1sl6x" />
            Secure checkout · Encrypted payment
          </p>

          <p className="mt-6 text-center text-[15px] leading-relaxed text-muted" data-id="element-253" data-mp="3b5qxga9wrft8">
            For less than the cost of many professional reference materials, you’ll have a structured educational toolkit you can return to
            whenever you need help organizing a sensory modulation case.
          </p>
        </div>
      </div>
    </section>;
}
function StackRow({
  icon,
  title,
  detail,
  value
}: {
  icon: React.ReactNode;
  title: string;
  detail: string;
  value: string;
}) {
  const isIncluded = value === 'Included';
  return <li className="flex items-start gap-3 py-4" data-id="element-254" data-mp="356nnh6ms1t62">
      <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-brand-soft text-brand" data-id="element-255" data-mp="3539hzpith3ue">{icon}</span>
      <div className="min-w-0 flex-1" data-id="element-256" data-mp="3evfcp70gdzda">
        <div className="flex items-start justify-between gap-3" data-id="element-257" data-mp="3ew76qdeejp1g">
          <p className="text-[16px] font-bold leading-snug text-ink" data-id="element-258" data-mp="3a4yvrcxfbvm6">{title}</p>
          <span className={`shrink-0 text-[15px] font-bold ${isIncluded ? 'text-cta-dark' : 'text-muted line-through'}`} data-id="element-259" data-mp="3a2um0ecug2dz">{value}</span>
        </div>
        <p className="mt-1 text-[14px] leading-snug text-muted" data-id="element-260" data-mp="3ivz928d7cyyd">{detail}</p>
      </div>
    </li>;
}